import type { Options as HighchartsOptions } from 'highcharts'

export const SOURCE_HUMANIZED_TRANSLATION = {
  SITE_CONCIERGE: 'Site Concierge',
  CALENDAR_DROP: 'Calendar share',
  EMAIL_DROP: 'Email extension',
  PLAYBOOK_DROP: 'Playbook',
  PROFILE_DROP: 'Drift Profile',
  PROFILE_LINK: 'Drift Profile',
  RESCHEDULE: 'Reschedule',
  SEQUENCE_DROP: 'Sequence email',
  NONE: 'None',
  FALLBACK_EMAIL: 'Fallback email',
  VIDEO_MEETING: 'Video meeting',
  PLAYBOOK_DROP_TEAM: 'Playbook',
}

export const STATUS_HUMANIZED_TRANSLATION = {
  ACTIVE: 'Scheduled',
  REQUESTED: 'Requested',
  CANCELED: 'Canceled',
  DELETED: 'Deleted',
  RESCHEDULED: 'Rescheduled',
  NO_SHOW: 'No-show',
  HELD: 'Held',
}

export const NON_DATE_BAR_CHART_OPTIONS_OLD = {
  xAxis: {
    type: 'category',
    categories: Object.values(STATUS_HUMANIZED_TRANSLATION).filter(
      (status) => status !== STATUS_HUMANIZED_TRANSLATION.REQUESTED
    ),
  },
} as Partial<HighchartsOptions>

export const NON_DATE_BAR_CHART_OPTIONS = {
  xAxis: {
    type: 'category',
    categories: Object.values(STATUS_HUMANIZED_TRANSLATION),
  },
} as Partial<HighchartsOptions>
